import { PlusCircleOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, MomentDatePicker, Texto } from '@gravitate-js/excalibrr'
import { datePickerValidators } from '@utils/datePickerValidator'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Form, Input } from 'antd'
import moment, { type Moment } from 'moment'
import { useState } from 'react'
import { useEasyOrderMovements } from '../MovementStoreProvider'

const fields = [
  {
    name: 'tractor',
    placeholder: 'Tractor #',
  },
  {
    name: 'driver',
    placeholder: 'Driver Name',
  },
  {
    name: 'attendant',
    placeholder: 'Attendant Name',
    rules: [{ required: true, message: `Attendant name is required.` }],
  },
  {
    name: 'delivery_date',
    label: 'Delivery Date',
    placeholder: 'Delivery Date',
    type: 'date',
    rules: [{ required: true, message: `Delivery date is required.` }],
  },
]

export function MetaDetailsForm() {
  const [selectedDate, setSelectedDate] = useState<Date | Moment | null>(null)

  const { form, isOrderReadOnly, isPotatoMode } = useEasyOrderMovements()

  return (
    <Horizontal flex={1} justifyContent='flex-start'>
      {fields.map((field) => (
        <Horizontal className='ml-4 py-4' alignItems='center' key={field.name}>
          {!isPotatoMode && (
            <Texto style={{ whiteSpace: 'nowrap' }} className='mr-3' category='heading-small'>
              {field.label || field.name}
            </Texto>
          )}
          <Form.Item
            name={field.name}
            noStyle={!field.rules}
            style={{ margin: field.rules?.length ? 0 : 'default' }}
            rules={field.rules}
          >
            {(() => {
              switch (field.type) {
                case 'date':
                  return (
                    // @ts-ignore
                    <MomentDatePicker
                      name={field.name}
                      showTime
                      showSecond={false}
                      style={{ width: '100%' }}
                      disabled={isOrderReadOnly}
                      disabledTime={(date) => {
                        if (moment(date).isSame(moment(), 'day')) {
                          return {
                            disabledHours: datePickerValidators.HOURS_PAST_ONLY,
                            disabledMinutes: datePickerValidators.MINUTES_PAST_ONLY,
                          }
                        }
                        return {
                          disabledHours: () => [],
                          disabledMinutes: () => [],
                        }
                      }}
                      disabledDate={datePickerValidators.DATE_PAST_ONLY}
                      onSelect={(date) => {
                        setSelectedDate(date)
                      }}
                      onChange={(date) => {
                        setSelectedDate(date)
                      }}
                      onOpenChange={(open) => {
                        if (open) {
                          if (!selectedDate) setSelectedDate(form.getFieldValue('delivery_date'))
                        }
                      }}
                    />
                  )
                default:
                  return (
                    <Input
                      disabled={isOrderReadOnly}
                      type='text'
                      name={field.name}
                      placeholder={field.placeholder}
                      size='middle'
                    />
                  )
              }
            })()}
          </Form.Item>
        </Horizontal>
      ))}
      <Horizontal flex={1} />
      <Horizontal style={{ gap: 12 }} alignItems='center' className='mr-4'>
        {!isOrderReadOnly && (
          <GraviButton
            buttonText={
              <Horizontal alignItems='center' style={{ gap: 8 }}>
                <PlusCircleOutlined />
                <span>Add Item</span>
              </Horizontal>
            }
            theme2
            appearance='outlined'
            onClick={() => {
              const currentMovements = form.getFieldValue('movements')
              form.setFieldsValue({
                movements: [
                  ...form.getFieldValue('movements'),
                  {
                    number: currentMovements[0]?.number,
                    date: currentMovements[0]?.date,
                    terminal: currentMovements[0]?.terminal,
                    supplier: currentMovements[0]?.supplier,
                    contract: '',
                  },
                ],
              })
            }}
          />
        )}
      </Horizontal>
    </Horizontal>
  )
}
